






























































































































































































import { mapGetters } from "vuex";
import Context from "@/mixins/context";
import { DataModules } from "@/store/modules/data";
import { FraudEventsFilters } from "@/data/filters/fraud";
import { FraudEventsSorters } from "@/data/sorters/fraud";
import { Component, Prop, Mixins, Inject } from "vue-property-decorator";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import store from "@/store";
import { InvoiceCategoryCode } from "@/models/invoices";
import { FraudStatusMap, FraudEventTypes } from "@/data/fraud";
import clientFilters from "@/data/filters/client";
import {
  IFraudMindProvider,
  IFraudMindProviderMethods
} from "@/models/providers/fraud";

@Component({
  methods: {
    addIPRule: event =>
      store.dispatch(`data/${DataModules.FRAUD_DETECTION}/addIPRule`, event)
  },
  computed: {
    ...mapGetters({
      isMultibrand: "brand/isMultibrand"
    })
  }
})
export default class FraudEventsTable extends Mixins(
  FilteringSortingTableStore,
  Context
) {
  // Inject
  @Inject({ from: "fraudMindProvider" })
  public $fraudProvider!: () => IFraudMindProvider;

  @Inject({ from: "fraudMindProviderMethods" })
  public $fraudMethods!: IFraudMindProviderMethods;

  // Props
  @Prop({ default: "brand" })
  public type!: string;
  @Prop({ default: null })
  public objectId!: string;
  @Prop({ default: false })
  public showClient!: boolean;

  // Data
  public mappedType = this.type === "order" ? "invoice" : this.type;
  public FraudEventTypes = FraudEventTypes();
  public FraudStatusMap = FraudStatusMap();
  public isMultibrand!: boolean;
  public filters = this.$_.concat(
    FraudEventsFilters().filter(
      i =>
        ["created_at", "status", "reason"].includes(i.key) ||
        i.group === this.type
    ),
    clientFilters().map(i => ({
      ...i,
      key: `client.${i.key}`,
      label: `${this.$t("_.client")}: ${i.label}`
    }))
  );
  public sorters = this.$_.cloneDeep(FraudEventsSorters);
  public loading = true;
  public filter = "";
  public dataModule: string = DataModules.FRAUD_DETECTION_EVENTS;

  // Lifecycle methos
  public created() {
    if (!this.contentAvailable) return;
    this.apiProps = this.apiPropsForType;
    this.getData();
  }

  // Getters
  public get contentAvailable() {
    return this.$userCan("list_fraud_events");
  }

  public get fraudObject() {
    return this.$fraudProvider().fraudObject;
  }

  public get canGetInvoiceFraudCheckData() {
    return this.$fraudProvider().canGetInvoiceFraudCheckData;
  }

  public get apiPropsForType() {
    return {
      with: "invoice,client,client.image,contract,user",
      brand_id: this.fraudObject.brand_id
    };
  }

  public get filterForType() {
    if (!this.objectId) return {};

    switch (this.mappedType) {
      case "client":
        return { "filter[client_id]": this.objectId };
      case "contract":
        return { "filter[contract_id]": this.objectId };
      case "order":
      case "invoice":
        return { "filter[invoice_id]": this.objectId };
      default:
        return {};
    }
  }

  // Methods
  openUserView(row) {
    this.$emit("close");
    this.$router.push({
      name: "adminUser",
      params: { userId: row.user_id }
    });
  }

  public openObjectView(to) {
    this.$emit("close");
    this.$router.push(to).catch(() => {
      //Mask error
    });
  }

  public getEventInfo(event) {
    if (!event) return {};
    /**
     * if there's an invoice_id then its an invoice event,
     * if theres a contract_id but no invoice_id then its a contract event,
     * if there's a client_id but no contract_id or invoice_id then its a client
     */
    return event.invoice_id
      ? event?.invoice?.category.slug === InvoiceCategoryCode.NEW_CONTRACT
        ? // Order
          {
            label: this.$t("_.order"),
            id: this.$_.get(event, "invoice.number"),
            to: {
              name: "adminClientOrder",
              params: { clientId: event.client_id, orderId: event.invoice_id }
            }
          }
        : //Invoice
          {
            label: this.$t("_.invoice"),
            id: this.$_.get(event, "invoice.number"),
            to: {
              name: "adminInvoice",
              params: { clientId: event.client_id, invoiceId: event.invoice_id }
            }
          }
      : event.contract_id // Contract
      ? {
          label: this.$t("_.contract"),
          id: ``
        }
      : event.client_id
      ? {
          label: this.$t("_.client"),
          id: "",
          to: {
            name: "adminClient",
            params: { clientId: event.client_id }
          }
        }
      : { label: this.$t("_.brand"), id: event.brand_id };
    // fallback, in theory it shouldn't go to brand
  }

  public openInvoiceFraudCheckData(invoiceId) {
    if (!this.canGetInvoiceFraudCheckData) return;

    this.$fraudMethods.openInvoiceFraudCheckData({
      invoiceId
    });
  }

  // overrides mixin method
  public getStoreParams(payload: any): Promise<any> {
    return this.$_.merge(payload, {
      type: this.isMultibrand ? "organisation" : this.type,
      params: {
        ...payload.params,
        ...this.filterForType
      }
    });
  }
}
